var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitchSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 24,
    viewBox: "0 0 39 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Container"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Background",
    width: 39,
    height: 24,
    rx: 12,
    fill: "#DFE5EB"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Knob",
    x: 1.5,
    y: 1.5,
    width: 21,
    height: 21,
    rx: 10.5,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchSvg);
export default __webpack_public_path__ + "static/media/SwitchSvg.7fc390b1a16c3e9df89c0e4ce1c71709.svg";
export { ForwardRef as ReactComponent };